import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useRef, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import Text from "noood/comp/text/Text";
import Icon from "noood/comp/ui/feather-icon/Icon";
import PickTimePopUp from "noood/comp/date/picker/PickTimePopUp";
import { FormContext } from "noood/contexts/contexts";
import { form_validator } from "noood/comp/form/FormFieldValidator";
import './PickTimePopUp';
export default function PickTime(props) {
  var _form$formObj2, _form$formObj3;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    pickTimePopUp = _useState2[0],
    setPickTimePopUp = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    timeStr = _useState4[0],
    setTimeStr = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    isHovered = _useState6[0],
    setIsHovered = _useState6[1];
  var fieldRef = useRef();
  var form = useContext(FormContext);
  var format_time = function format_time(sqlTimeFormat) {
    if (sqlTimeFormat !== void 0 && sqlTimeFormat !== null) {
      if (sqlTimeFormat !== null && sqlTimeFormat !== void 0 && sqlTimeFormat.match(/[0-9]{2}:[0-9]{2}:00/)) {
        var _sqlTimeFormat$split = sqlTimeFormat.split(":"),
          _sqlTimeFormat$split2 = _slicedToArray(_sqlTimeFormat$split, 3),
          h = _sqlTimeFormat$split2[0],
          m = _sqlTimeFormat$split2[1],
          s = _sqlTimeFormat$split2[2];
        var formatted = '';
        if (Number(h) > 12) {
          formatted = "0".concat(Number(h) - 12).slice(-2);
          formatted += ":".concat(m, " pm");
        } else {
          formatted = "".concat(Number(h) == 0 ? 12 : h, ":").concat(m, " am");
        }
        return formatted;
      } else return sqlTimeFormat;
    } else return '';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.label && /*#__PURE__*/React.createElement(Text, null, props.label), /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "PickTime__ui.base evmkeg23 ev1y0btm7 ev4745u8 ev1tgzv6z ev78zum5 ev1qjc9v5 evxwrc4x ev1y7ric0"
  }, {
    ref: fieldRef,
    onMouseEnter: function onMouseEnter() {
      setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsHovered(false);
    }
  }), props.icon && /*#__PURE__*/React.createElement("div", {
    className: "PickTime__ui.icon_container ev6wrskw evmzs88n PickTime__ui.center ev6s0dn4 ev78zum5 evl56j7k"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon
  })), /*#__PURE__*/React.createElement("input", _extends({}, {
    className: "PickTime__ui.input ev5yr21d evjbqb8w evc342km evuy8w9f ev1717udv evh8yej3 ev1ghz6dp ev17e5z5g ev1a2a7pz evq4dhtl"
  }, {
    name: props.name,
    placeholder: "HH:MM AA",
    onClick: function onClick() {
      var _form$formObj;
      setPickTimePopUp(/*#__PURE__*/React.createElement(PickTimePopUp, {
        key: "popup-".concat(props.name),
        sender: fieldRef.current,
        contextSetter: setPickTimePopUp,
        value: format_time((_form$formObj = form.formObj) === null || _form$formObj === void 0 ? void 0 : _form$formObj[props.name]),
        _collect: function _collect(timeStrFromPopup) {
          setTimeStr(timeStrFromPopup);
          form.__collect(props.name, timeStrFromPopup, form_validator.validate(props.validations, timeStrFromPopup));
        }
      }));
    },
    value: format_time((_form$formObj2 = form.formObj) === null || _form$formObj2 === void 0 ? void 0 : _form$formObj2[props.name]),
    onChange: function onChange(e) {
      form.__collect(props.name, e.target.value, form_validator.validate(props.validations, e.target.value));
    }
  })), ((_form$formObj3 = form.formObj) === null || _form$formObj3 === void 0 ? void 0 : _form$formObj3[props.name]) !== void 0 && (props.clearable === void 0 || props.clearable) && isHovered && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      marginRight: 5
    },
    onClick: function onClick() {
      form.__collect(props.name, null, []);
      setTimeStr(undefined);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "PickTime__ui.clear evw4jnvo ev1qx5ct2 ev1m3ak92 ev78zum5 ev6s0dn4 evl56j7k ev1h2kqdt evjbqb8w ev3dtjww ev1ko5yus"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "x",
    color: "var(--shade-40)",
    size: 13
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 0
    }
  }, pickTimePopUp));
}
PickTime.displayName = '__pick_time';

// @ts-ignore
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".ev4745u8{border-color:var(--shade-10)}", 2000);
_inject(".ev1tgzv6z{height:var(--field-height)}", 4000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1qjc9v5{align-items:stretch}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev5yr21d{height:100%}", 4000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".evc342km{border-width:0}", 2000);
_inject(".evuy8w9f{line-height:17px}", 3000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".ev17e5z5g{color:var(--text-color)}", 3000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".evq4dhtl::placeholder{color:var(--shade-20)}", 8000);
_inject(".ev6wrskw{padding-left:4px}", 4000);
_inject(".evmzs88n{padding-right:4px}", 4000);
_inject(".evw4jnvo{width:20px}", 4000);
_inject(".ev1qx5ct2{height:20px}", 4000);
_inject(".ev1m3ak92{border-radius:20px}", 2000);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".ev1ko5yus:active{background-color:var(--shade-20)}", 3170);